import { Link } from "react-router-dom";
import getDateAndTime from "../../../helper/getDateAndTime";

const BlogEntry = ({ post_id, title, rating, content, thumbnail, date, type }) => {

  const dateAndTime = getDateAndTime(date);

  let formattedContent = content.replace(/(!\[.*\]\(.*\))+/g, "");
  formattedContent = formattedContent.replace(/(<iframe.*<\/iframe>)/, "");

  let blogEntryTierClass = "";
  // switch (rating) {
  //   case 'S':
  //     blogEntryTierClass = "blogEntryS";
  //     break;
  //   case 'A':
  //     blogEntryTierClass = "blogEntryA";
  //     break;
  //   case 'B':
  //     blogEntryTierClass = "blogEntryB";
  //     break;
  //   case 'C':
  //     blogEntryTierClass = "blogEntryC";
  //     break;
  //   case 'F':
  //     blogEntryTierClass = "blogEntryF";
  //     break;
  //   default:
  //     blogEntryTierClass = "blogEntryF";
  // }
  
  type = type.charAt(0).toUpperCase() + type.slice(1);


  return (
    <div className="blogEntryContainer">
      <div className="row h-100 g-2">


        <div className="col-8 h-100 ">
          <div className="d-flex flex-column h-100">
            <Link to={'/blog/post/' + post_id} className="blogEntryTitle" >{title}<small> </small></Link>

            <small className="blogEntryContent">{formattedContent}</small>


            <div className="d-flex mt-auto ">
              <div className="d-flex">
                <div className="blogEntryTypeContainer">
                  <small>{type}</small>
                </div>

                <div className={`blogEntryTierContainer`}>
                  <small className="blogEntryTier"><small className={blogEntryTierClass}>{rating}</small></small>

                </div>


              </div>


              <div className="ms-auto">
                <small className="blogEntryDate">{dateAndTime[1]}, {dateAndTime[0]}</small>
              </div>
            </div>
          </div>
        </div>
        <div className="col-4 d-flex justify-content-end">
          <img src={thumbnail ? thumbnail : require('../../../assets/icons/pnf.webp')} alt="pnf" className="blogEntryThumbnail" />
        </div>

      </div>
    </div>
  )
}



export default BlogEntry